// @ commons
const { APIGet } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { ESTATE_REGISRATION_TYPE } = require('constants/mortgageRequestEstates');

const requestInmueblesInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_INMUEBLES_REQUEST
});

const requestInmueblesSuccess = (list, isFetching) => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_INMUEBLES_SUCCESS,
    data: {
        list,
        isFetching
    }
});

const requestInmueblesFailure = (error) => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_INMUEBLES_FAILURE,
    data: { error }
});

const resetInmueblesData = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_INMUEBLES_RESET
});

const resetEstatesReducer = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_RESET
});

const requestPopulations = fetchingPopulationsCounter => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_REQUESTS_POPULATIONS,
    data: { fetchingPopulationsCounter }
});

const requestRegisters = fetchingRegistersCounter => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_REQUEST_REGISTERS,
    data: {fetchingRegistersCounter}
});

const setProvinceName = (index, provinceName) => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_SET_PROVINCE_NAME,
    data: {
        index,
        provinceName
    }
});

const setPopulationName = (index, populationName) => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_SET_POPULATION_NAME,
    data: {
        index,
        populationName
    }
});

const setRegisterName = (index, registerName) => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_SET_REGISTER_NAME,
    data: {
        index,
        registerName
    }
});

const setEstateState = (id, state) => ({
    type: actionTypes.MORTGAGE_REQUEST_SET_ESTATE_STATE,
    data: {
        id,
        state
    }
});

const setEstatesState = estates => ({
    type: actionTypes.MORTGAGE_REQUEST_SET_ESTATES_STATE,
    data: { estates }
});

const setMultiplesEstatesState = estates => ({
    type: actionTypes.MORTGAGE_REQUEST_SET_MULTIPLE_ESTATE_STATE,
    data: { estates }
});

const clearEstatesState = () => ({
    type: actionTypes.MORTGAGE_REQUEST_CLEAR_ESTATES_STATE
});

const requestRegister = (index, provinceId, populationId, registerId, fetchingRegistersCounter) => dispatch => {
    dispatch(requestRegisters(fetchingRegistersCounter));

    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestRegistersData',
        params: {
            query: {
                provinceId,
                populationId
            }
        }
    })
    .then(response => {
        const reistersList = response.data;
        const register = reistersList.find(register => register.id === registerId);
        const registerName = !!register ? register.name : '';

        dispatch(setRegisterName(index, registerName));
    })
    .catch(response => {
        throw response;
    });
}

const requestPopulation = (index, provinceId, populationId, fetchingPopulationsConunter) => dispatch => {
    dispatch(requestPopulations(fetchingPopulationsConunter));

    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestPopulationsData',
        params: {
            query: {
                provinceId
            }
        }
    })
    .then(response => {
        const populations = response.data;
        const population = populations.find(population => population.id === populationId);
        const populationName = !!population ? population.name : '';

        dispatch(setPopulationName(index, populationName));
    })
    .catch(response => {
        throw response;
    });
}

const updateEstates = provinces => (dispatch, getState) => {
    const immEstatesList = getState().mortgageRequestInmuebles.get('list');

    let fetchingPopulationsCounter = 0;
    let fetchingRegistersCounter = 0;

    immEstatesList.forEach((immEstate, index) => {
        const provinceId = immEstate.get('provinceId');
        const populationId = immEstate.get('populationId');
        const registerId = immEstate.get('registerId');
        const idType = immEstate.get('idType');
        const isRegData = idType === ESTATE_REGISRATION_TYPE.REG || idType === ESTATE_REGISRATION_TYPE.REG_DATA;

        if (!!provinceId) {
            if (!!populationId) {
                fetchingPopulationsCounter++;
                dispatch(requestPopulation(index, provinceId, populationId, fetchingPopulationsCounter));
            }

            if (!!populationId && registerId && isRegData) {
                fetchingRegistersCounter++
                dispatch(requestRegister(index, provinceId, populationId, registerId, fetchingRegistersCounter));
            }
        }

        const province = provinces.find(province => province.id === provinceId);
        const provinceName = !!province ? province.name : '';

        dispatch(setProvinceName(index, provinceName));
    });
};

const requestProvinces = () => dispatch => {
    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestProvincesData'
    })
    .then(response => {
        dispatch(updateEstates(response.data));
    })
    .catch(response => {
        throw response;
    });
};

const requestInmuebles = (useV2 = false) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestInmuebles;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        const endpoint = useV2 ? 'mortgageRequestInmueblesV2' : 'mortgageRequestInmuebles';
        dispatch(requestInmueblesInProgress());
        return APIGet({
            dispatch,
            endpoint
        })
        .then(response => {
            const isFetching = useV2 && response.data.length > 0;

            dispatch(requestInmueblesSuccess(response.data, isFetching));

            if (isFetching) {
                dispatch(requestProvinces());
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestInmueblesFailure(response.error));
            } else {
                throw response;
            }
        })
    } else {
        return Promise.resolve();
    }

};

const resetInmuebles = () => dispatch => {

    dispatch(resetInmueblesData());

    dispatch(resetEstatesReducer());
};

module.exports = {
    requestInmuebles,
    resetInmuebles,
    setEstateState,
    clearEstatesState,
    setEstatesState,
    setMultiplesEstatesState
};
